import { Injectable } from '@angular/core';
import { PromotionService } from '@app/core/services/promotion.service';
import * as fromRoot from '@app/reducers';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, concatMap, map, withLatestFrom } from 'rxjs/operators';
import * as fromUploader from '../reducers';
import { SendActions } from '../actions';
import { Promotion } from '@app/shared/models/promotion';

@Injectable()
export class SendEffects {

  loadPromotionsInternal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SendActions.loadPromotionsInternal),
      withLatestFrom(
        this.store$.select(fromRoot.getCurrentDomain),
        this.store$.select(fromRoot.getSelectedLanguage),
        this.store$.select(fromRoot.getTheme),
      ),
      concatMap(([action, domain, language, theme]) => {
        if (domain.team) {
          return this.promotionService.listPromotionsInternal(domain.team).pipe(
            map((resp) => SendActions.loadPromotionsSuccess({ promotions: resp.promotions, language })),
            catchError(error => of(SendActions.loadPromotionsFailure({ error: error.message })))
          );
        } else if (theme) {
          const { reveal } = theme;
          const promotion: Promotion = {
            button: reveal?.callToAction?.label,
            link: reveal?.callToAction?.url,
            title: reveal.teasing.text,
            text: reveal.text,
            medias: reveal.medias.map(media => ({ type: media.type, url: media.url, sourceId: media.url, sourceUrl: media.url, position: media.position })).sort((a, b) => a.position - b.position),
            language,
            status: 'Enabled',
            teaserDisabled: true,
          };

          return of(SendActions.loadPromotionsSuccess({ promotions: [promotion], language: '*' }));
        } else {
          return this.promotionService.listManagedPromotionsInternal().pipe(
            map((resp) => SendActions.loadPromotionsSuccess({ promotions: resp.promotions, language })),
            catchError(error => of(SendActions.loadPromotionsFailure({ error: error.message })))
          );
        }
      })
    ));

  loadPromotionsSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SendActions.loadPromotionsSuccess),
      withLatestFrom(
        this.store$.select(fromUploader.getPromotionLoaded),
        this.store$.select(fromRoot.getCurrentDomain),
      ),
      concatMap(([_, promotion, domain]) => {
        if (!promotion) { return [{ type: 'No promotion' }]; }
        if (domain.team) {
          return this.promotionService.getTeamPromotion(domain.team, promotion.id).pipe(
            map((resp) => SendActions.loadPromotionSuccess({ promotion: resp.promotion })),
            catchError(error => of(SendActions.loadPromotionFailure({ error: error.message })))
          );
        } else {
          return [{ type: "noop managed promotion" }];
        }
      })
    ));


  constructor(
    private actions$: Actions,
    private readonly promotionService: PromotionService,
    private store$: Store<fromUploader.State & fromRoot.State>,
  ) { }

}
